export const timeRangeOptions = [
  { label: 'Last 5 minutes', value: '5m' },
  { label: 'Last 10 minutes', value: '10m' },
  { label: 'Last 30 minutes', value: '30m' },
  { label: 'Last 1 hour', value: '1h' },
  { label: 'Last 4 hours', value: '4h' },
  { label: 'Last 12 hours', value: '12h' },
  { label: 'Last 1 day', value: '1d' },
  { label: 'Last 3 days', value: '3d' },
  { label: 'Last 7 days', value: '7d' },
  { label: 'Custom Range', value: 'custom' },
];
